import Button from "components/button/button";
import { useLocation } from "react-router-dom";

type SuccessState = {
  isGift?: boolean;
  recipientEmails?: string[];
};

const ThankYouPage = () => {
  const location = useLocation();
  const state = (location.state as SuccessState) || {};
  const isGift = !!state.isGift;
  const recipientCount = state.recipientEmails?.length ?? 0;

  if (isGift) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-56px)] p-6 text-center bg-brand">
        <h1 className="text-display-lg text-white mb-6">
          Thank you for your purchase.
        </h1>
        <p className="mb-3 text-base font-normal leading-5 text-white max-w-[520px]">
          An email has been sent to the {recipientCount === 1 ? "recipient" : "recipients"} of your gift with a redemption code.
        </p>
        <p className="mb-6 text-base font-normal leading-5 text-white max-w-[520px]">
          {recipientCount === 1 ? "They" : "They each"} will use that code to create an account and verify {recipientCount === 1 ? "their" : "their"} email before signing in.
        </p>
        <Button variant="primary" onClick={() => window.location.replace("/")}>
          Return Home
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-56px)] p-6 text-center bg-brand">
      <h1 className="text-display-lg text-white mb-6">
        Please verify your email to continue.
      </h1>
      <p className="mb-6 text-base font-normal leading-5 text-white max-w-[520px]">
        Your account was successfully created. We sent a verification link to your email.
      </p>
      <button
        type="button"
        onClick={() => window.location.replace("/login")}
        className="text-sm underline text-white opacity-80 hover:opacity-100"
      >
        Already verified? Sign in
      </button>
    </div>
  );
};

export default ThankYouPage;
